import { render, staticRenderFns } from "./SntSelectCustomerCategoryList.vue?vue&type=template&id=37d090d2&"
import script from "./SntSelectCustomerCategoryList.vue?vue&type=script&lang=js&"
export * from "./SntSelectCustomerCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports